(function () {
  var root = document.getElementById("FlavorSwipe");
  if (!root) return;

  var rail = root.querySelector("[data-fs-rail]");
  var hit = root.querySelector("[data-fs-hit]") || rail;
  var items = [].slice.call(root.querySelectorAll(".fs-item"));
  if (!rail || items.length < 1) return;

  var n = items.length;
  var i = 0;
  var startX = 0;
  var startY = 0;
  var dx = 0;
  var dy = 0;
  var axis = "";
  var dragging = false;
  var cardBox = root.querySelector(".fs-card");
  var card = {
    price: root.querySelector("[data-fs-price]"),
    size: root.querySelector("[data-fs-size]"),
    title: root.querySelector("[data-fs-title]"),
    desc: root.querySelector("[data-fs-desc]"),
    cta: root.querySelector("[data-fs-cta]"),
  };

  function wrapDelta(d) {
    if (d > n / 2) d -= n;
    if (d < -n / 2) d += n;
    return d;
  }

  function layout(offsetPx) {
    offsetPx = offsetPx || 0;
    var w = rail.offsetWidth || window.innerWidth || 1;
    items.forEach(function (el, k) {
      var d = wrapDelta(k - i);
      var x = d * 70 + (offsetPx / w) * 70;
      var s = d === 0 ? 1 : 0.72;
      var o = d === 0 ? 1 : Math.max(0.22, 0.55 - Math.abs(d) * 0.18);
      el.style.transition = dragging && axis === "x" ? "none" : "transform .38s cubic-bezier(.22,.7,.3,1), opacity .38s";
      el.style.transform = "translate3d(" + x + "%,0,0) scale(" + s + ")";
      el.style.opacity = String(o);
      el.style.zIndex = String(10 - Math.abs(d));
      el.classList.toggle("is-on", k === i);
    });
  }

  function fill() {
    var el = items[i];
    if (!el || !cardBox) return;
    cardBox.style.opacity = "0.4";
    window.setTimeout(function () {
      if (card.price) card.price.textContent = el.getAttribute("data-price") || "";
      if (card.size) card.size.textContent = el.getAttribute("data-size") || "";
      if (card.title) card.title.textContent = el.getAttribute("data-title") || "";
      if (card.desc) card.desc.textContent = el.getAttribute("data-desc") || "";
      if (card.cta) {
        card.cta.textContent = el.getAttribute("data-cta") || "Get it";
        var href = el.getAttribute("data-href");
        if (href) card.cta.setAttribute("href", href);
      }
      cardBox.style.opacity = "1";
    }, 80);
  }

  function go(dir) {
    i = (i + dir + n) % n;
    layout(0);
    fill();
  }

  function client(e) {
    var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
    return { x: t.clientX, y: t.clientY };
  }

  function onStart(e) {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    var p = client(e);
    startX = p.x;
    startY = p.y;
    dx = 0;
    dy = 0;
    axis = "";
    dragging = true;
  }

  function onMove(e) {
    if (!dragging) return;
    var p = client(e);
    dx = p.x - startX;
    dy = p.y - startY;

    if (!axis) {
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if (axis === "x") {
        try { hit.setPointerCapture(e.pointerId); } catch (err) {}
      } else {
        dragging = false;
        layout(0);
        return;
      }
    }

    if (axis !== "x") return;
    if (e.cancelable) e.preventDefault();
    layout(dx);
  }

  function onEnd(e) {
    if (!dragging && axis !== "x") {
      axis = "";
      dx = 0;
      dy = 0;
      return;
    }
    var wasX = axis === "x";
    var tap = !axis && Math.abs(dx) < 10 && Math.abs(dy) < 10;
    dragging = false;
    axis = "";

    if (wasX) {
      var w = rail.offsetWidth || 390;
      var need = Math.min(48, w * 0.14);
      if (dx < -need) go(1);
      else if (dx > need) go(-1);
      else layout(0);
    } else if (tap && e && e.pointerType !== "touch") {
      var p = client(e);
      var r = hit.getBoundingClientRect();
      if (p.x < r.left + r.width * 0.28) go(-1);
      else if (p.x > r.left + r.width * 0.72) go(1);
    } else {
      layout(0);
    }
    dx = 0;
    dy = 0;
  }

  hit.addEventListener("pointerdown", onStart);
  hit.addEventListener("pointermove", onMove, { passive: false });
  hit.addEventListener("pointerup", onEnd);
  hit.addEventListener("pointercancel", function () {
    dragging = false;
    axis = "";
    dx = 0;
    dy = 0;
    layout(0);
  });

  window.addEventListener("resize", function () { layout(0); }, { passive: true });
  layout(0);
})();
